import React from 'react';
import PropTypes from 'prop-types';
import { useThemeContext } from '../../ThemeSettings';
import { THEMES_STATE_KEYS } from '../../../../../../utils/themes';
import { ReactComponent as Logo } from '../../../../../../assets/img/icn-blue-logo.svg';
import IconThemePreview1 from '../../../../../../assets/img/theme-preview/IconThemePreview1';
import IconThemePreview2 from '../../../../../../assets/img/theme-preview/IconThemePreview2';
import IconThemePreview3 from '../../../../../../assets/img/theme-preview/IconThemePreview3';

import IconThemePreviewDark1 from '../../../../../../assets/img/theme-preview/IconThemePreviewDark1';
import IconThemePreviewDark2 from '../../../../../../assets/img/theme-preview/IconThemePreviewDark2';
import IconThemePreviewDark3 from '../../../../../../assets/img/theme-preview/IconThemePreviewDark3';

import {
  constants as customerConfigurationsConstants
} from '../../../../../../redux/customerConfigurations';

import './sass/smartscan-preview.scss';

function SmartScanPreview({ themeType, logoUrl }) {
  const { themes } = useThemeContext();

  return (
    <div className="smartscan-preview-wrapper">
      <div className="smartscan-preview-wrapper__row1">
        <h2>Theme preview</h2>
      </div>
      <div className="smartscan-preview-wrapper__row2 img-wrapper">
        {
          themeType === customerConfigurationsConstants.THEME.DEFAULT ? (
            <IconThemePreview1
              headingColor={themes[THEMES_STATE_KEYS.headingColor]}
              paragraphColor={themes[THEMES_STATE_KEYS.paragraphColor]}
              primaryBtnTextColor={themes[THEMES_STATE_KEYS.primaryButtonTextColor]}
              primaryBtnBgColor={themes[THEMES_STATE_KEYS.primaryButtonBackgroundColor]}
            />
          ) : (
            <IconThemePreviewDark1
              headingColor={themes[THEMES_STATE_KEYS.headingColor]}
              paragraphColor={themes[THEMES_STATE_KEYS.paragraphColor]}
              primaryBtnTextColor={themes[THEMES_STATE_KEYS.primaryButtonTextColor]}
              primaryBtnBgColor={themes[THEMES_STATE_KEYS.primaryButtonBackgroundColor]}
            />
          )
        }
        <div className={`preview-logo-container ${themeType === customerConfigurationsConstants.THEME.DEFAULT ? 'default' : 'dark'}`}>
          {logoUrl ? (
            <img className="default-preview-logo" src={logoUrl} alt="" />
          ) : (
            <Logo className="default-preview-logo" />
          )}
        </div>
      </div>
      <div className="smartscan-preview-wrapper__row3 img-wrapper">
        {
          themeType === customerConfigurationsConstants.THEME.DEFAULT ? (
            <IconThemePreview2
              errorColor={themes[THEMES_STATE_KEYS.errorColor]}
              headingColor={themes[THEMES_STATE_KEYS.headingColor]}
              paragraphColor={themes[THEMES_STATE_KEYS.paragraphColor]}
              primaryBtnTextColor={themes[THEMES_STATE_KEYS.primaryButtonTextColor]}
              primaryBtnBgColor={themes[THEMES_STATE_KEYS.primaryButtonBackgroundColor]}
              SecondaryBtnTextColor={themes[THEMES_STATE_KEYS.secondaryButtonTextColor]}
              SecondaryBtnBgColor={themes[THEMES_STATE_KEYS.secondaryButtonBackgroundColor]}
            />
          ) : (
            <IconThemePreviewDark2
              errorColor={themes[THEMES_STATE_KEYS.errorColor]}
              headingColor={themes[THEMES_STATE_KEYS.headingColor]}
              paragraphColor={themes[THEMES_STATE_KEYS.paragraphColor]}
              primaryBtnTextColor={themes[THEMES_STATE_KEYS.primaryButtonTextColor]}
              primaryBtnBgColor={themes[THEMES_STATE_KEYS.primaryButtonBackgroundColor]}
              secondaryBtnTextColor={themes[THEMES_STATE_KEYS.secondaryButtonTextColor]}
              secondaryBtnBgColor={themes[THEMES_STATE_KEYS.secondaryButtonBackgroundColor]}
            />
          )
        }
      </div>
      <div className="smartscan-preview-wrapper__row4 img-wrapper">
        {
          themeType === customerConfigurationsConstants.THEME.DEFAULT ? (
            <IconThemePreview3
              headingColor={themes[THEMES_STATE_KEYS.headingColor]}
              paragraphColor={themes[THEMES_STATE_KEYS.paragraphColor]}
              primaryBtnTextColor={themes[THEMES_STATE_KEYS.primaryButtonTextColor]}
              primaryBtnBgColor={themes[THEMES_STATE_KEYS.primaryButtonBackgroundColor]}
            />
          ) : (
            <IconThemePreviewDark3
              headingColor={themes[THEMES_STATE_KEYS.headingColor]}
              paragraphColor={themes[THEMES_STATE_KEYS.paragraphColor]}
              primaryBtnTextColor={themes[THEMES_STATE_KEYS.primaryButtonTextColor]}
              primaryBtnBgColor={themes[THEMES_STATE_KEYS.primaryButtonBackgroundColor]}
            />
          )
        }
      </div>
    </div>
  );
}

SmartScanPreview.propTypes = {
  logoUrl: PropTypes.string,
  themeType: PropTypes.number.isRequired
};

export default SmartScanPreview;
